import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';

import { CreateAudienceModal } from '../../components';
import {
  hideCreateAudienceModal,
  clearAllQueriesRequest,
  requestAudienceDetails,
  clearConversationQueryRequest,
} from '../../actions';

class CreateAudienceModalContainer extends Component {
  render() {
    const {
      createAudienceModal,
      hideCreateAudienceModal,
      clearAllQueriesRequest,
      queryBuilder,
      clearConversationQueryRequest,
    } = this.props;

    const { isVisible, queryBuilderProps } = createAudienceModal;

    if (!isVisible) {
      return null;
    }

    return (
      <Suspense fallback={<div />}>
        <CreateAudienceModal
          {...queryBuilderProps}
          onCreateAudienceModalClose={() => {
            clearAllQueriesRequest();
            hideCreateAudienceModal();

            if (queryBuilder.queryBuilderType === 'conversation') {
              clearConversationQueryRequest();
            }
          }}
        />
      </Suspense>
    );
  }
}

const mapDispatchToProps = {
  hideCreateAudienceModal,
  clearAllQueriesRequest,
  requestAudienceDetails,
  clearConversationQueryRequest,
};

const mapStateToProps = state => ({
  createAudienceModal: state.createAudienceModal,
  queryBuilder: state.queryBuilder,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAudienceModalContainer);
